import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { FSFMotoLightBoxActions } from '../constants/fsf_moto_light_box/fsf_moto_light_box_actions';

class FSFMotoLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return { visible: false };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.FSF_MOTO_LIGHTBOX_ACTION) {
            switch (action.type) {
                case FSFMotoLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        this.__emitChange();
                    }

                    break;

                case FSFMotoLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const FSFMotoLightBoxStore = new FSFMotoLightBoxStoreClass(Dispatcher);
export { FSFMotoLightBoxStore };